<div 
  class="header-menu-travel-info-dropdown"
  (clickOutside)="onClickOutside()"
>
  <button
    class="header-menu-travel-info-dropdown__button"
    type="button"
    id="topMenutravel-infoCollapse"
    role="button"
    [ngClass]="{ 'header-menu-travel-info-dropdown__button--opened': !collapsed }"
    [attr.aria-expanded]="!collapsed"
    aria-controls="top-bar-travel-info-dropdown"
    (click)="toggleCollapsed()"
  >
    {{ headerCopy.travelInfo }}
    <app-svg-icon
      class="header-menu-travel-info-dropdown__chevron-down-icon"
      icon="chevron-down-icon"
      fill="white"
      [width]="14"
      [height]="14"
    ></app-svg-icon>
  </button>
  <ul
    class="header-menu-travel-info-dropdown__dropdown-menu dropdown-menu"
    id="top-bar-travel-info-dropdown"
    aria-labelledby="topMenutravel-infoCollapseDropdown"
    [collapse]="collapsed"
    [isAnimated]="false"
  >
    @if (isFlifoEnabled) {
      <li role="menuitem">
        <div (click)="goTo(headerCopy.travelInfo1.link)">{{ headerCopy.travelInfo1.name }}</div>
      </li>
    }
    <li role="menuitem">
      <div (click)="goTo(headerCopy.travelInfo2.link)">{{ headerCopy.travelInfo2.name }}</div>
    </li>
    <li role="menuitem">
      <div (click)="goTo(headerCopy.travelInfo3.link)">{{ headerCopy.travelInfo3.name }}</div>
    </li>
    <li role="menuitem">
      <div (click)="goTo(headerCopy.travelInfo4.link)">{{ headerCopy.travelInfo4.name }}</div>
    </li>
    <li role="menuitem">
      <div (click)="goTo(headerCopy.travelInfo5.link)">{{ headerCopy.travelInfo5.name }}</div>
    </li>
    <li role="menuitem">
      <div (click)="goTo(headerCopy.travelInfo6.link)">{{ headerCopy.travelInfo6.name }}</div>
    </li>
    <li role="menuitem">
      <div (click)="goTo(headerCopy.travelInfo7.link)">{{ headerCopy.travelInfo7.name }}</div>
    </li>
  </ul>
</div>
